<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader class="d-flex align-items-center flex-wrap justify-content-between pb-0 header-with-nav">
                    <div>
                        <strong class="mr-4">Заказы</strong>
                        <CButton color="primary" variant="outline" @click="showZeroOrderModal = true">
                            Создать нулевой заказ
                        </CButton>
                    </div>
                    <OrdersTabLinks class="mb-0" />
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <OrdersTable
                            :list.sync="items"
                            :total.sync="itemsCount"
                            :use-filter="true"
                            :use-sorter="true"
                            @set-sorter="setSorter"
                            @set-filter="setFilter"
                        />
                    </template>
                </CCardBody>
            </CCard>
            <CCard>
                <CCardHeader class="d-flex justify-content-between align-items-center">
                    <strong>Последние чаты</strong>
                    <CLink to="/chats">Все чаты</CLink>
                </CCardHeader>
                <CCardBody>
                    <div v-if="loadingChats" class="table__preloader">
                        <CSpinner color="primary" />
                    </div>
                    <template v-else>
                        <div v-if="!chats.length" class="text-muted">
                            Активных чатов пока нет
                        </div>
                        <div v-else class="chat-summary-cards">
                            <ChatSummaryCard
                                v-for="chat in chats"
                                :key="chat.chat_id"
                                :chat="chat"
                                @select="openChat"
                            />
                        </div>
                    </template>
                </CCardBody>
            </CCard>
            <CCard class="table__oppacity">
                <CCardHeader class="d-flex align-items-center flex-wrap justify-content-between header-with-nav">
                    <strong>Отложенные заказы</strong>
                    <div class="flex items-center">
                        <div class="col-form-label">Показать</div>
                        <CSwitch
                            class="ml-2"
                            color="success"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="showDelayed"
                        />
                    </div>
                </CCardHeader>
                <CCardBody v-if="showDelayed">
                    <DelayedOrdersTable
                        :list.sync="delayedItems"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <ZeroOrderModal
            :open="showZeroOrderModal"
            @close="showZeroOrderModal = false"
            @order-created="onZeroOrderCreated"
        />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import OrdersTable from '@/components/orders/OrdersTable';
    import DelayedOrdersTable from '@/components/orders/DelayedOrdersTable';
    import OrdersTabLinks from '@/components/orders/OrdersTabLinks';
    import ZeroOrderModal from '@/components/orders/ZeroOrderModal';
    import ChatSummaryCard from '@/components/chats/ChatSummaryCard';
    import { cilInfo } from '@coreui/icons';
    import { CButton } from '@coreui/vue';

    export default {
        name: 'Orders',

        icons: {
            cilInfo
        },

        components: {
            OrdersTable,
            DelayedOrdersTable,
            OrdersTabLinks,
            ZeroOrderModal,
            ChatSummaryCard,
        },

        data() {
            return {
                loading: true,
                loadingOrdersError: false,
                loadingOrdersErrorText: '',
                loadingDelayedOrdersError: false,
                loadingDelayedOrdersErrorText: '',
                items: [],
                itemsCount: 0,
                delayedItems: [],
                sorter: '',
                filter: '',
                timerId: null,
                delayedTimerId: null,
                showDelayed: false,
                showZeroOrderModal: false,
                loadingChats: true,
                chats: [],
                chatsTimerId: null,
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            sorter: 'loadData',
            filter: 'loadData',
            showDelayed() {
                localStorage.setItem('delayed-orders-table-show', this.showDelayed);
            }
        },

        async mounted() {
            // If business administrator - go to particular page
            const settings = JSON.parse(localStorage.getItem('settings'));
            if (settings.is_business_admin) {
                if (settings.restaurants && settings.restaurants.length) {
                    this.$router.push('/orders/orders-rd');
                } else if (settings.florists && settings.florists.length) {
                    this.$router.push('/orders/orders-fd');
                } else if (settings.laundries && settings.laundries.length) {
                    this.$router.push('/orders/orders-ld');
                } else if (settings.grocers && settings.grocers.length) {
                    this.$router.push('/orders/orders-gd');
                } else if (settings.pharmacies && settings.pharmacies.length) {
                    this.$router.push('/orders/orders-pd');
                } else if (settings.entities && settings.entities.length) {
                    this.$router.push('/orders/orders-ed');
                } else {
                    return;
                }
            }
            this.showDelayed = !!JSON.parse(localStorage.getItem('delayed-orders-table-show'));
            await this.loadData();
            await this.loadDelayedItems();
            await this.loadActiveChats();
            this.loading = false;
            this.timerId = setInterval(this.loadData, 10000);
            this.delayedTimerId = setInterval(this.loadDelayedItems, 10000);
            this.chatsTimerId = setInterval(() => this.loadActiveChats(false), 10000);
        },

        beforeDestroy() {
            clearInterval(this.timerId);
            clearInterval(this.delayedTimerId);
            clearInterval(this.chatsTimerId);
        },

        methods: {
            async loadData() {
                let filter = null;
                try {
                    filter = JSON.parse(this.filter);
                } catch (e) {
                    // console.log(e);
                }
                const params = {
                    main: 1,
                    sorter: this.sorter,
                    in_work: true,
                    filter,
                };
                try {
                    const resp = await Vue.axios.get('/orders', { params });
                    this.items = resp.data;
                    if(!resp.data.total) {
                        this.itemsCount = resp.data.length;
                    } else {
                        this.itemsCount = resp.data.total;
                    };
                    this.loadingOrdersError = false;
                }
                catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки заказов. ' + err);
                };
            },
            async loadDelayedItems() {
                try {
                    const resp = await Vue.axios.get('/delayed-orders');
                    this.delayedItems = resp.data;
                    this.loadingDelayedOrdersError = false;
                }
                catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки отложенных заказов. ' + err);
                };
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
            setSorter(sorter) {
                this.sorter = sorter;
            },
            setFilter(filter) {
                const filterObj = {
                    concierge_id: (filter && filter.concierge_id ? filter.concierge_id : []).map(i => i.value),
                    courier_id: (filter && filter.courier_id ? filter.courier_id : []).map(i => i.value),
                    status: (filter && filter.status ? filter.status : []).map(i => i.value),
                    tower: (filter && filter.tower ? filter.tower : []).map(i => i.value),
                    type: (filter && filter.type ? filter.type : []).map(i => i.value),
                };
                this.filter = JSON.stringify(filterObj);
            },
            onZeroOrderCreated(order) {
                // Переходим на страницу созданного заказа
                if (order && order.id) {
                    this.$router.push(`/orders/${order.id}`);
                } else {
                    // Просто обновляем список заказов
                    this.loadData();
                }
            },
            async loadActiveChats(useLoader = true) {
                if (useLoader) {
                    this.loadingChats = true;
                }
                try {
                    const { data } = await Vue.axios.get('/chats/active', {
                        params: {
                            page: 1,
                            limit: 5,
                        },
                    });
                    this.chats = data.items || [];
                } catch (e) {
                    this.$root.$emit('showError', 'Не удалось загрузить активные чаты');
                } finally {
                    this.loadingChats = false;
                }
            },
            openChat(chat) {
                this.$router.push({
                    name: 'Chat',
                    params: {
                        chatId: chat.chat_id,
                    },
                });
            },
        },
    };
</script>
<style scoped>
.header-with-nav ul.nav.nav-tabs {
    border-bottom: 0;
}
.table__preloader {
    display: flex;
    width: 100%;
    height: 100px;
    justify-content: center;
    align-items: center;
}
.table__oppacity {
    opacity: .4;
    transition: .3s ease;
}
.table__oppacity:hover {
    opacity: 1;
    transition: .3s ease;
}
</style>
